import request from '@/utils/request.js'
// 注册查询手机号是否存在
export function fetchMobile(num) {
    return request.get(`/company/users/${num}/exist`)
}
// 注册时发送验证码
export function sendCode(params) {
    return request.post(`/company/sms/sendcode`, {
        ...params
    })
}
// 注册
export function register(params) {
    return request.post(`/company/users/register`, {
        ...params
    })
}
// 使用验证码登陆
export function login(params) {
    return request.post(`/company/users/login/smscode`, {
        ...params
    })
}
// 如果登陆 根据用户id 查询审核状态
export function getAuthstatus(params) {
    return request.post(``, {
        ...params
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js